<template>
      <div class="content">
        <div class="container-fluid">
      <div class="row">
          <div class="col-md-12">
            <div class="nav-bar box-horizontal mb-0">
              <i class="material-icons d-block text-secondary mr-2 pointer p-2" @click="$router.go(-1)">arrow_back</i>
              <div class="flex-1">
                <h3 class="m-0">{{data.title}}</h3>
                <p class="mb-0">Semua pembukuan akan tercatat sesuai bulan yang ditentukan</p>
              </div>
            </div>
            <router-link :to="{ name: 'pembukuan-pengeluaran-tambah'}"  class="btn btn-info m-0 mt-4" >Tambah Pembukuan</router-link>
            <div class="card">
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <th width="40px">No.</th>
                      <th>Keterangan</th>
                      <th>Admin</th>
                      <th>Kategori</th>
                      <th>Jumlah</th>
                      <th>Tanggal </th>
                    </thead>
                      <!-- LOADING -->
                    <tbody v-show="data.loading">
                      <tr>
                        <td colspan="8"><Loading></Loading></td>
                      </tr>
                      <tr>
                        <td colspan="8"><Loading></Loading></td>
                      </tr>
                      <tr>
                        <td colspan="8"><Loading></Loading></td>
                      </tr>
                    </tbody>
                      <!-- DATA -->
                    <tbody v-show="!data.loading">
                      <tr v-for="(u, index) in theGet.data.List">
                        <td>{{ index+1 }}</td>
                        <td>{{ u.keterangan }}</td>
                        <td>{{ u.by }}</td>
                        <td style="text-transform: uppercase">{{ u.kategori }}</td>
                        <td>
                          <strong class="text-danger" v-if="u.type == 'keluar'">{{ myGlobal.ribu(u.jumlah) }}</strong>
                          <strong class="text-warning" v-else-if="u.type == 'setor'">{{ myGlobal.ribu(u.jumlah) }}</strong>
                          <strong class="text-success" v-else>{{ myGlobal.ribu(u.jumlah) }}</strong>
                        </td>
                        <td>{{u.jam}}<br>{{ myGlobal.tglIndo(u.tanggal) }}</td>
                      </tr>
                      <!-- NULL -->
                      <tr v-if="theGet.data.List == null">
                        <td></td>
                        <td>Tidak ada Data </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          
      </div>
        </div>
      </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 
import Loading from '@/globalFunc/Loading' 

export default {
  name: 'Beranda',
	components: { 
      "Loading" : Loading
	}, 
  setup() {
    const data = reactive({
      loading: true,
      title: "Rincian Pembukuan"
    })

    const theGet = {
        data: reactive({
            List: [],
            Total: "0",
        }),
        datae(kategori,filter) {
            var datax = {
                token: 'TangTung '+sessionStorage.getItem('myToken'),
                bulan: sessionStorage.getItem('bulanIdBase'),
                tahun: sessionStorage.getItem('tahunBase'),
                filter: filter,
                kategori: kategori
            };
        
            var apiUrl = inter.Pengeluaran();
            myGlobal.call(datax,apiUrl).then(x => {

              data.loading = false;
              if (x.status == true) {
                this.data.List = x.data;
                this.data.Total = x.pesan.keluar;
              
              } else {
                theGet.data.List = null;
              }
            })
        }
    }
    return {
      data,
      myGlobal,
      theGet
    }
  },
  mounted () {
    document.title = "Rincian Pembukuan";

    this.data.namaQ = sessionStorage.getItem('admin');

		console.log(JSON.stringify(this.$route.params));
    let kategori = this.$route.params.kategori;
    if (kategori == "gaji") {
      this.data.title = "Rincian Pengeluaran Gaji";
      this.theGet.datae("1", "keluar");
    } else if (kategori == "baru") {
      this.data.title = "Rincian Pengeluaran Pasang Baru";
      this.theGet.datae("2", "keluar");
    } else if (kategori == "alat") {
      this.data.title = "Rincian Pengeluaran Perbaikan Alat";
      this.theGet.datae("3", "keluar");
    } else if (kategori == "bandwith") {
      this.data.title = "Rincian Pengeluaran Bandwith";
      this.theGet.datae("4", "keluar");
    } else if (kategori == "kangtagih") {
      this.data.title = "Rincian Pengeluaran Bayar Kang Tagih";
      this.theGet.datae("5", "keluar");
    } else if (kategori == "listrik") {
      this.data.title = "Rincian Pengeluaran Listrik / PDAM / Pulsa";
      this.theGet.datae("6", "keluar");
    } else if (kategori == "marketing") {
      this.data.title = "Rincian Pengeluaran Bayar Marketing";
      this.theGet.datae("7", "keluar");
    } else if (kategori == "marketing") {
      this.data.title = "Rincian Pengeluaran Bayar Marketing";
      this.theGet.datae("7", "keluar");
    } else if (kategori == "masuklain") {
      this.data.title = "Rincian Pemasukkan Lain-lain";
      this.theGet.datae("", "masuk");
    } else {
      if (kategori == "") {
        this.data.title = "Rincian Pengeluaran Lain-lain";
        this.theGet.datae("", "keluar");
      } else {
        this.theGet.datae("all", "all");
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/pembukuan/pengeluaran.vue